if (!customElements.get('preorder-waitlist')) {
  customElements.define('preorder-waitlist', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.onClick = this.open.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.onClick);
      this.stopWatching();
    }

    open(event) {
      event.preventDefault();
      const variantId = this.closest('form')?.querySelector('[name="id"]')?.value;
      if (!variantId || !window.BIS?.createPopover) return;

      if (!this.bisPopover) {
        const product = JSON.parse(this.button.dataset.productData);
        const selector = this.closest('.product').querySelector('variant-radios');
        const variants = JSON.parse(selector.querySelector('[type="application/json"]').textContent);
        product.variants = product.variants.map(variant => ({
          ...variant,
          inventory_quantity: variants.find(item => item.id === variant.id)?.inventory_quantity
        }));
        // Enable AMP's notification eligibility for zero-stock pre-orders only
        // in this popup; leave the store's automatic button settings unchanged.
        this.bisPopover = window.BIS.createPopover({
          product,
          productHandle: product.handle,
          preorder_enabled: true,
          button: { visible: false }
        });
        // AMP binds every popover to #BIS_trigger, even with its button hidden.
        // This popup opens only through our button; do not reopen it on sold-out clicks.
        document.removeEventListener('click', this.bisPopover.triggerHandler);
      }
      this.stopWatching();
      const request = this.openRequest;
      this.bisPopover.ready.then(() => {
        if (!this.isConnected || request !== this.openRequest) return;
        const frame = this.bisPopover.form.frame;
        // Focus handling for the popup lives in waitlist-popup-a11y.js.
        const show = () => {
          if (!this.isConnected || request !== this.openRequest) return;
          this.bisPopover.show({ variantId });
        };
        // AMP's ready callback covers product data, not the iframe's load/render.
        if (frame.contentDocument?.querySelector('#variants')) {
          show();
        } else {
          this.loadingFrame = frame;
          this.onFrameLoad = show;
          frame.addEventListener('load', show, { once: true });
        }
      });
    }

    stopWatching() {
      this.openRequest = (this.openRequest || 0) + 1;
      this.loadingFrame?.removeEventListener('load', this.onFrameLoad);
      this.loadingFrame = null;
      this.onFrameLoad = null;
    }
  });
}
